import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ztfezrm7u7: FaireBrandEntity = {
  token: "b_ztfezrm7u7",
  type: "brand",
  name: "Poppy & Pine",
  avatarUrl:
    "https://cdn.faire.com/fastly/e2477f0ca943b6f6f34d6a5d2a1534ae249d804382a2f9cd8e6b98c494610646.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3379239e68042b1e12f29afd959d52c03e68a4b0b5eead04ada8d5c1299ac016.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e2477f0ca943b6f6f34d6a5d2a1534ae249d804382a2f9cd8e6b98c494610646.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3379239e68042b1e12f29afd959d52c03e68a4b0b5eead04ada8d5c1299ac016.png",
  location: "Lake Saint Louis, MO, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 209,
  isTopShop: true,
  isInsider: true,
  description:
    "\nFAST SHIPPING & High Quality SCREEN PRINTED Boutique Apparel!  We aim to ship within 24-72 business hours!  Please message us if you need it quickly :)  Hi! I’m Rachel, a natural born crafter and lover of graphic tees!  With an obsession for design, a background in marketing and an understanding of the struggle to balance work and life with a family, Poppy & Pine was born in 2013.   As a mother to 3 boys, this company is the daughter I decided to create, branded after the little girl’s name I always loved, Penelope “Poppy”.\n\nWhy graphic tees you ask???  Poppy & Pine is a lifestyle graphic apparel company, and our tees are made for all of life’s moments - a way to express yourself to the world, a way to relate to and encourage each other and a way to make others smile.  \n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:49.369Z",
    importedBy: "entity-db-cli",
  },
};
